import {
  BillingRulesTab,
  PaymentHistoryTab,
  VerifierBillingSettingsTab,
  VerifierBillingSettingsTabType,
} from 'src/components/verifier/VerifierBillingSettingsCVAdminManager';

export const VerifierBillingSettingsTabs: Array<VerifierBillingSettingsTabType> = [
  {
    label: 'Billing Rules',
    key: VerifierBillingSettingsTab.BillingRules,
    component: <BillingRulesTab />,
  },
  {
    label: 'Payment History',
    key: VerifierBillingSettingsTab.PaymentHistory,
    component: <PaymentHistoryTab />,
  },
];
